import React, { useEffect, useRef, useState } from 'react';
import { Tooltip } from 'antd';
import PropTypes from 'prop-types';
import style from './index.less';

function PopoverCol({ text = '', popoverContent = null }) {
  const span = useRef(null);
  const [usePopover, setUsePopover] = useState(false);

  useEffect(() => {
    if (span.current) {
      const wrap = span.current.parentElement;
      if (wrap.scrollWidth > wrap.clientWidth) {
        setUsePopover(true);
      }
    }

    return function unmont() {};
  }, []);

  if (text !== '') {
    if (!usePopover) {
      return (
        <div className={style.text}>
          <span ref={span}>{text}</span>
        </div>
      );
    }
    return (
      <Tooltip title={text}>
        <div className={`${style.text} ${style.text_overflow}`}>
          <span>{text}</span>
        </div>
      </Tooltip>
    );
  }
  return null;
}

PopoverCol.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  popoverContent: PropTypes.element
};

export default PopoverCol;
